import DeviceStatusType = CASLink.Device.Ui.ViewModel.Device.DeviceStatusType;

export const DeviceStatusPriority = new Map<DeviceStatusType, number>([
    [ DeviceStatusType.InActive, 1 ],
    [ DeviceStatusType.Active, 2 ],
    [ DeviceStatusType.Stale, 3 ],
    [ DeviceStatusType.NotResponding, 4 ],
    [ DeviceStatusType.DuplicateModbusId, 5 ],
]);
